<template>
    <div id="done-task">
        <div class="kanban-task-table">
            <supsis-table
                :columns="columns"
                :rows="filterTasks"
                :bottom-pagination="true"
                :pagination-cursor="paginationCursor"
                :options="tableOptions"
                @cursor-changed="(cursor) => (paginationCursor = cursor)"
            />
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";
import { getOrUpdateFilters } from "../../utils/persistenceStorage";
import SupsisTable from "../SupsisTable.vue";
import LowIcon from "../svg/task/LowIcon.vue";
import LowestIcon from "../svg/task/LowestIcon.vue";
import MediumIcon from "../svg/task/MediumIcon.vue";
import HighIcon from "../svg/task/HighIcon.vue";
import HighestIcon from "../svg/task/HighestIcon.vue";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";
import { deleteTask } from "../../api/tasks"; // Bu satırı ekleyin

const filters = getOrUpdateFilters("kanbanlist");
export default {
    name: "DoneTask",
    components: {
        SupsisTable,
        Avatar,
        LowIcon,
        LowestIcon,
        MediumIcon,
        HighIcon,
        HighestIcon,
        SupsisButton,
    },
    props: {
        details: {
            type: Object,
            default: () => ({}),
        },
        visitorId: {
            type: String,
            default: null,
        },
        assignees: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t("message.createdDate"),
                    field: "createdAt",
                    key: "createdAt",
                    renderBodyCell: ({ row }) => {
                        return this.formatDate(row.createdAt);
                    },
                },
                {
                    // title: this.$t("message.name"),
                    title: "Görev",
                    field: "title",
                    key: "title",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class={"title-cell"} v-tippy={{ content: row.title }}>
                                {row.title}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("task.stage"),
                    field: "pipelineStage",
                    key: "pipelineStage",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="supsis-tag-el" style={{ "--pipeline-color": row.pipelineStage.color }}>
                                {row.pipelineStage.name}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("task.owner"),
                    field: "owner",
                    key: "owner",
                    renderBodyCell: ({ row }) => {
                        return (
                            this.users[row.owner] && (
                                <div class="agent-detail">
                                    <Avatar
                                        size={25}
                                        key={row.owner}
                                        src={this.users[row.owner].gravatar}
                                        username={this.users[row.owner].name}
                                        v-tippy={{
                                            followCursor: true,
                                            placement: "bottom-end",
                                        }}
                                        content={this.users[row.owner].email}
                                    />
                                    <div v-tippy={{ content: this.users[row.owner].name }}>
                                        {this.users[row.owner].name.substring(0, 8) + "..."}
                                    </div>
                                </div>
                            )
                        );
                    },
                },
                {
                    title: this.$t("task.assignees"),
                    field: "assignees",
                    key: "assignees",
                    renderBodyCell: ({ row }) => {
                        return (
                            this.users[row.assignees[0]] && (
                                <div class="agent-detail">
                                    <Avatar
                                        size={25}
                                        key={row.assignees[0]}
                                        src={this.users[row.assignees[0]].gravatar}
                                        username={this.users[row.assignees[0]].name}
                                        v-tippy={{
                                            followCursor: true,
                                            placement: "bottom-end",
                                        }}
                                        content={this.users[row.assignees[0]].email}
                                    />
                                    <div v-tippy={{ content: this.users[row.assignees[0]].name }}>
                                        {this.users[row.assignees[0]].name.substring(0, 8) + "..."}
                                    </div>
                                </div>
                            )
                        );
                    },
                },
                {
                    title: this.$t("message.startDate"),
                    field: "startDate",
                    key: "startDate",
                    renderBodyCell: ({ row }) => {
                        return this.formatDate(row.startDate);
                    },
                },
                {
                    title: "Priority",
                    field: "priority",
                    key: "priority",
                    renderBodyCell: ({ row }) => {
                        return row.priority === "low" ? (
                            <LowIcon />
                        ) : row.priority === "lowest" ? (
                            <LowestIcon />
                        ) : row.priority === "medium" ? (
                            <MediumIcon />
                        ) : row.priority === "high" ? (
                            <HighIcon />
                        ) : row.priority === "highest" ? (
                            <HighestIcon />
                        ) : (
                            ""
                        );
                    },
                },
                {
                    title: this.$t("message.endDate"),
                    field: "endDate",
                    key: "endDate",
                    renderBodyCell: ({ row }) => {
                        return row.endDate ? this.formatDate(row.endDate) : "";
                    },
                },
                {
                    title: this.$t("message.transactions"),
                    field: "_id",
                    key: "_id",
                    copyDisabled: true,
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="task-transactions">
                                <SupsisButton
                                    xxsmall
                                    icon
                                    onClick={() => {
                                        this.addNewWindow({
                                            type: "editor-task",
                                            title: row.title,
                                            payload: {
                                                taskId: row._id,
                                            },
                                        });
                                    }}
                                >
                                    <i class="material-icons">edit</i>
                                </SupsisButton>
                                <SupsisButton xxsmall icon danger onClick={() => this.confirmDeleteTask(row)}>
                                    <i class="material-icons">delete</i>
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ],
            tasks: [],
            paginationCursor: {
                total: 0,
                page: filters.page || 1,
                perPage: filters.perPage || 20,
            },
            tableOptions: {
                bodyCellEvents: ({ row, column, rowIndx }) => {
                    return {
                        dblclick: (event) => {
                            this.addNewWindow({
                                type: "edit-workflow",
                                title: row.title,
                                payload: {
                                    taskId: row._id,
                                },
                            });
                        },
                    };
                },
            },
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
        }),
        filterTasks() {
            return this.tasks.filter((task) => {
                const visibility = task.workflow.visibility || {};
                const users = visibility.users || [];
                const departments = visibility.departments || [];
                const userSubjects = this.user.subjects || [];
                const userId = this.user._id || null;
                if (users.includes(userId) && departments.length === 0) {
                    return true;
                } else if (departments.some((dept) => userSubjects.includes(dept)) && users.length === 0) {
                    return true;
                } else if (users.includes(userId) || departments.some((dept) => userSubjects.includes(dept))) {
                    return true;
                } else if (users.length === 0 && departments.length === 0) {
                    return true;
                }
                return false;
            });
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            getListDoneTask: "tasks/getListDoneTask",
        }),
        formatDate(date) {
            return date && this.$moment(date).format("YYYY/MM/DD HH:mm");
        },
        getTasks() {
            getOrUpdateFilters("kanbanlist", {
                assignees: this.assignees,
                page: this.paginationCursor.page,
                perPage: this.paginationCursor.perPage,
            });
            this.getListDoneTask({
                page: this.paginationCursor.page,
                perPage: this.paginationCursor.perPage,
                workflowId: this.details.workflowId,
            }).then(({ data, total }) => {
                this.tasks = data;
                this.paginationCursor.total = total;
            });
        },
        confirmDeleteTask(task) {
            this.$confirm({
                title: "Silme İşlemi",
                content: "Bu görevi silmek istediğinize emin misiniz?",
                okText: this.$t("message.yes"),
                cancelText: this.$t("message.no"),
                onOk: () => {
                    this.deleteTask(task._id);
                },
            });
        },
        deleteTask(taskId) {
            deleteTask(taskId)
                .then(() => {
                    this.getTasks(); // Tabloyu yenile
                    this.$message.success(`Görev başarıyla silindi`);
                })
                .catch((error) => {
                    console.error("Görev silinirken hata oluştu:", error);
                    this.$message.error(`Görev silinirken hata oluştu`);
                });
        },
    },
    mounted() {
        this.getTasks();
    },
    watch: {
        paginationCursor: {
            deep: true,
            handler() {
                this.getTasks();
            },
        },
        assignees: {
            deep: true,
            handler() {
                this.getTasks();
            },
        },
    },
};
</script>
<style lang="scss" scoped>
#done-task {
    .task-transactions {
        display: flex;
        gap: 5px;
        align-items: center;

        .supsis-button {
            padding: 5px !important;
            height: 27px !important;

            .material-icons {
                font-size: 15px;
            }
        }
    }

    .kanban-task-search {
        display: flex;
        justify-content: center;
        margin-top: 9px;
    }

    .title-cell {
        max-width: 300px;
        //one-line and ellipsis
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .kanban-task-table {
        padding: 10px;
    }
    .supsis-tag-el {
        padding: 4px 10px;
        border: 1px solid var(--pipeline-color);
        color: var(--pipeline-color);
        border-radius: 100px;
        width: max-content;
    }

    .agent-detail {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .paginator {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
</style>
